import axiosInstance from "./axiosInstance";
import {
  USER_BASE_URL,
  OPENCONSULTATION,
  CONSULTATION,
  GETCHATDATA,
  FETCHCHAT,
  SEND_PDF_TO_EMAIL,
  SEND_CONDITION,
  ADDITIONAL_MEDICAL_REPORT,
} from "../API";

export const getAIResponse = async (prompt, sessionId, userId, headers) => {
  const res = await axiosInstance.post(`/predict`, { prompt, sessionId, userId }, { headers, timeout: 80000 })
  return res.data;
};
export const getConditionSummary = async (sessionId, userId, headers) => {
  const res = await axiosInstance.post(`/summary`, { sessionId, userId }, { headers, timeout: 80000 })
  return res.data;
};
export const getConditionPromptFromAI = async (sessionId, userId, headers) => {
  const res = await axiosInstance.post(`/condition-word`, { sessionId, userId }, { headers, timeout: 80000 })
  return res.data.condition;
};
export const getAdminAfterSession = async (sessionId, userId, headers) => {
  const res = await axiosInstance.post(`/admin-aftersession`, { sessionId, userId }, { headers, timeout: 80000 })
  return res.data;
};
export const getRecommendedTests = async (sessionId, userId, headers) => {
  const res = await axiosInstance.post(`/recommended-tests`, { sessionId, userId }, { headers, timeout: 80000 })
  return res.data;
};


/** Fetch an open consultation by ID. */
export const fetchOpenConsultation = async (consultationId, headers) => {
  const url = `${OPENCONSULTATION}?consultation_id=${consultationId}`;
  const response = await axiosInstance.get(url, { headers });
  return response.data;
};

/**  Create a new consultation. */
export const createConsultation = async (data, headers) => {
  const response = await axiosInstance.post(CONSULTATION, data, { headers });
  return response.data;
};

/** Fetch chat history for a consultation. */
export const fetchChatHistory = async (consultationId, headers) => {
  const response = await axiosInstance.get(`${FETCHCHAT}?consultation_id=${consultationId}`, { headers });
  return response.data;
};

/** Store a chat message (text). */
export const storeChatMessage = async (consultationId, message, isUserMsg, headers) => {
  const payload = {
    consultation_id: consultationId,
    sender: isUserMsg ? "User" : "AiBot",
    receiver: isUserMsg ? "AiBot" : "User",
    message,
    language: "ENGLISH",
  };
  const response = await axiosInstance.post(GETCHATDATA, payload, { headers });
  return response.data;
};

/** Upload a file as a chat message */
export const uploadChatFile = async (file, consultationId, TOKEN) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("consultation_id", consultationId);
  formData.append("sender", "User");
  formData.append("receiver", "AiBot");
  formData.append("language", "ENGLISH");

  const response = await axiosInstance.post(GETCHATDATA, formData, {
    headers: { token: TOKEN, "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

/** Upload additional medical report PDF.*/
export const uploadMedicalReport = async (file, consultationId, headers) => {
  const formData = new FormData();
  formData.append("medical_report", file);
  formData.append("consultationId", consultationId);

  const response = await axiosInstance.post(
    ADDITIONAL_MEDICAL_REPORT,
    formData,
    { headers: { ...headers, "Content-Type": "multipart/form-data" } },
  );
  return response.data;
};

/** Send the consultation PDF to the user's email. */
export const sendPdfToEmail = async (formData, headers) => {
  const response = await axiosInstance.post(SEND_PDF_TO_EMAIL, formData, { headers });
  return response.data;
};

/**  Update the condition for a consultation. */
export const updateCondition = async (consultationId, condition, diagnosticData, headers) => {
  const formData = new FormData();
  formData.append("condition", condition);
  formData.append("_id", consultationId);
  formData.append("diagnostic_data", JSON.stringify(diagnosticData));

  const response = await axiosInstance.put(SEND_CONDITION, formData, { headers });
  return response.data;
};

/**  Parse AI response text into Q&A sections. */
export const parseAIResponse = (response) => {
  if (!response || !response.response) return null;
  const text = response.response;
  const sections = [];
  let parts = [];
  const spaceParts = text.split("Question :").filter((part) => part.trim());
  spaceParts.forEach((part) => {
    if (part.includes("Question:")) {
      const subParts = part
        .split("Question:")
        .filter((subPart) => subPart.trim());
      parts.push(...subParts);
    } else { parts.push(part); }
  });
  parts.forEach((part) => {
    const answerIndex = part.indexOf("Answer:") !== -1 ? part.indexOf("Answer:") : part.indexOf("Answer :");
    if (answerIndex !== -1) {
      const question = part.substring(0, answerIndex).trim();
      const answerStartIndex = part.indexOf("Answer:") !== -1 ? answerIndex + 7 : answerIndex + 8;
      let answer = part.substring(answerStartIndex);
      const nextQuestionIndex = answer.search(/Question\s*:/);
      if (nextQuestionIndex !== -1) { answer = answer.substring(0, nextQuestionIndex) }
      answer = answer.trim();
      if (question && answer) { sections.push({ question, answer }) }
    }
  });
  return sections;
};

/** Standard AI error handler — returns a user-friendly fallback string. */
export const handleAIError = (error) => {
  if (error.code === "ECONNABORTED") {
    return "Request timed out. The server is taking too long to respond.";
  }
  return "I'm sorry, there was an error processing your request. Please try again later.";
};
